export enum CommunicationProvider {
  Twilio = "twilio",
  RingCentral = "ring_central",
}

export enum TwilioDeviceState {
  Incoming = "incoming",
  Ongoing = "ongoing",
  Ringing = "ringing",
  Idle = "idle",
}

export enum TwilioCallActions {
  Accept = "accept",
  Cancel = "cancel",
  Disconnect = "disconnect",
  Error = "error",
  Mute = "mute",
  Reconnected = "reconnected",
  Reconnecting = "reconnecting",
  Reject = "reject",
  Warning = "warning",
  WarningCleared = "warning-cleared",
}

export enum TwilioCallDirection {
  Outgoing = "outgoing",
  Incoming = "incoming",
}

export enum TwilioCallEvents {
  Error = "error",
  TokenWillExpire = "tokenWillExpire",
  Incoming = "incoming",
  Unregistered = "unregistered",
  TransportClosed = "transportClosed",
}

export enum TwilioCallErrors {
  AccessTokenExpired = "AccessTokenExpired",
  AccessTokenInvalid = "AccessTokenInvalid",
  ConnectionError = "ConnectionError",
  TransportError = "TransportError",
}

export enum TwilioCallQualityWarningEvents {
  ConstantAudioInputLevel = "constant-audio-input-level",
}
